import { Component, EventEmitter, Inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BIModulesService } from '../../bi-modules.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { Subject, Subscription } from 'rxjs';
@Component({
  selector: 'BI-Popup',
  templateUrl: './BI-Popup.component.html',
  styleUrls: ['./BI-Popup.component.scss'],
})
export class BIPopupComponent {
  
  @Input() Title!: string;
  @Input() DisplayCancel!: boolean;
  @Input() DisplayOk: boolean = true;
  @Input() Width!: string;

  @Output() OnOpen = new EventEmitter<any>();
  @Output() OnClose = new EventEmitter<any>();
  @Output() OnOk = new EventEmitter<any>();
  
  AllowSave!: Subject<boolean>;
  StopSaveSubscription!: Subscription;

  @ViewChild('dialogContent') dialogContentTemplate!: TemplateRef<any>;
  dialogRef: MatDialogRef<any> | undefined;
  
  
  constructor(public biService: BIModulesService
    , private messages: MessageService,public dialog: MatDialog
    ) {}
    ngOnInit() {
      this.AllowSave = new Subject<boolean>();
    this.AllowSave.next(true);
    }
  public CloseDialog(){
    this.OnClose.emit();
    this.dialogRef?.close();
  }
  public async OK(){
    await this.BeforeActionSave();
    this.StopSaveSubscription?.unsubscribe();
    this.StopSaveSubscription = this.AllowSave?.subscribe((res: any) => {
      if (res) {
        this.OnOk.emit();
        this.CloseDialog();
      }
    });
    
  }
  openDialog(): void {
    this.OnOpen.emit();
    this.dialogRef = this.dialog.open(this.dialogContentTemplate, {
    width: this.Width ?? '75vw'
    });
    
  }
  BeforeActionSave(): void {
  }
}
